export default __webpack_public_path__ + "static/media/10.fda2cbc9.jpg";